import { render, staticRenderFns } from "./bendOver.vue?vue&type=template&id=008b5740&scoped=true&"
import script from "./bendOver.vue?vue&type=script&lang=js&"
export * from "./bendOver.vue?vue&type=script&lang=js&"
import style0 from "./bendOver.vue?vue&type=style&index=0&id=008b5740&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008b5740",
  null
  
)

export default component.exports